import { sessionAt } from './format';

export const E_TRANSFER_EMAIL = 'leaguepay@ftlovolleyball.ca';

/** How long an approved team has to pay, counted from the approval email. */
export const PAYMENT_WINDOW_HOURS = 48;

/** When an approval email sent at `now` asks for payment by, in local time. */
export function paymentDeadline(now: Date): string {
  return sessionAt(now.getTime() + PAYMENT_WINDOW_HOURS * 3_600_000);
}

export function eTransferMemo({
  season,
  flavour,
  teamName,
  captainName,
  code,
}: {
  season: string;
  flavour: string;
  teamName: string;
  captainName: string;
  code: string;
}): string {
  return [season, flavour, teamName, captainName, code]
    .filter((part) => part !== '')
    .join(' - ');
}
